import React from "react";
import { Sparkles } from "lucide-react";
import { GOLDEN_LIGHT } from "@/config/deck-settings";
import { BRAND } from "@/constants/testIds";

/** Founder Edition badge — Golden Light (#D4AF37) accent. */
export default function FounderBadge({ number = null, className = "" }) {
  return (
    <div
      data-testid={BRAND.founderBadge}
      className={`inline-flex items-center gap-2 px-3 py-1 font-overline bg-[#080808] ${className}`}
      style={{
        color: GOLDEN_LIGHT,
        border: `1px solid ${GOLDEN_LIGHT}66`,
        boxShadow: `0 0 18px ${GOLDEN_LIGHT}1f`,
      }}
    >
      <Sparkles size={12} strokeWidth={1.5} />
      Founder{number ? ` · No. ${number}` : ""}
    </div>
  );
}
